<mat-card class="decoration-card">
    <mat-card-content>
        <mat-toolbar *ngIf="!isReadonly">
            <button mat-icon-button class="crud_action" matTooltip="update" [disabled]="!isContentChanged" (click)="updateRecommendation()" *ngIf="!isReadonly">
                <mat-icon>save</mat-icon>
            </button>

            <span class="example-spacer"></span>

            <button mat-icon-button class="crud_action" matTooltip="add a recommendation" (click)="createRecommendation()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>

            <button mat-icon-button class="crud_action" matTooltip="delete" (click)="btnDeleteClicked()" *ngIf="!isReadonly">
                <mat-icon>delete_outline</mat-icon>
            </button>
        </mat-toolbar>

        <form name="myForm" class="example-form" (change)="onContentChange()">
            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>SN</mat-label>
                <input matInput type="text" name="sn" [(ngModel)]="recommendation.sn" [readonly]="isReadonly">
            </mat-form-field>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Description</mat-label>
                <textarea matInput type="text" name="description" [(ngModel)]="recommendation.description" [readonly]="isReadonly"></textarea>
            </mat-form-field>

            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [class.isReadonly]="isReadonly" [appearance]="fieldAppearance">
                            <mat-label>Type</mat-label>
                            <mat-select name="type" [(ngModel)]="selectedRecommendationType" (ngModelChange)="recommendationTypeChanged()">
                                @for (recType of recommedationTypes; track recType) {
                                <mat-option [value]="recType">{{recType.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field></td>

                    <td><mat-form-field class="example-full-width" [class.isReadonly]="isReadonly" [appearance]="fieldAppearance">
                            <mat-label>Closed?</mat-label>
                            <mat-select name="closed" [(ngModel)]="selectedCloseState" (ngModelChange)="closeStateChanged()">
                                @for (closed of closedStates; track closed) {
                                <mat-option [value]="closed">{{closed.expression}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field></td>

                </tr>
            </table>

        </form>


    </mat-card-content>
</mat-card>